import React, { useEffect, useMemo, useState } from "react"
import { Modal } from "@wantable/Shared/Components"
import LoginForm from "../LoginForm/LoginForm"
import User from "./User"
import LoggedOutUser from "./LoggedOutUser"
import SignUpForm from "../SignUpForm/SignUpForm"
import ForgotPasswordForm from "../ForgotPasswordForm/ForgotPasswordForm"
import { ModalType}  from "../types"
import useSwitchMenu from "@wantable/Shared/src/hooks/useSwitchMenu"
import { useScreenSize } from "@wantable/Shared"

const menus = require('/assets/mobilemenu.json');
interface MenuProps {
  isLoggedIn: boolean;
  openedModal: ModalType;
  selectedMenu: string;
  onAfterLogin?: () => void;
  onLogout: () => void;
  openModal: () => void;
}

const Menu = (props: MenuProps) => {
  const [modal, setModal] = useState<ModalType>(null)
  const [menuLoaded, setMenuLoaded] = useState<boolean>(false)
  const selectedMenu = useMemo(() => props.selectedMenu, [props.selectedMenu])
  const prevMenu = useSwitchMenu(selectedMenu)
  const { width, height } = useScreenSize();
  const mobileView = useMemo(() => (width && width > 780 ? false : true), [width]);
  const desktopView = useMemo(() => (width && width < 780 ? false : true), [width]);

  const navParent = document.getElementById('slide-menu')
  let navParentDesktop = document.getElementById('menu-wrapper')

  useEffect(() => {
    setModal(props.openedModal);
  }, [props.openedModal]);

  useEffect(() => {
    renderMobileMenus()
    allList()
  }, [menuLoaded])

  useEffect(() => {
    if (navParentDesktop == null) {
      // menu-wrapper is added to the page in code that's controlled with headless-header
      // so there's a non-zero chance that it isn't rendered by the time this runs
      setTimeout(() => {navParentDesktop = document.getElementById('menu-wrapper')}, 150)
    }
    if (desktopView && !mobileView && navParentDesktop != null) {
      renderDesktopMenus()
      allList()
    }
  }, [selectedMenu, mobileView, desktopView, navParentDesktop])

  const closeModal = () => {
    setModal(null);
  };

  const renderMobileMenus = () => {
    iterateJsonMenu(menus)
    setMenuLoaded(true)
  }

  const renderDesktopMenus = () => {
    if (prevMenu && prevMenu != selectedMenu) {
      iterateJsonMenuDesktop(menus, false)
    }
    else {
      iterateJsonMenuDesktop(menus)
    }
  }

  const allList = () => {
    let allList = document.querySelectorAll('li[data-position]')

    if (allList.length) {
      allList.forEach((each) => each.removeAttribute('data-position'))
    }
  }

  // #region Menus
  {/* @ts-ignore */}
  function iterateJsonMenu(menus, initial = true, key = '', mobile = true) {
    const ul = document.createElement('ul')
    //check if its initial then append ul or else append inside the li

    if (initial) {
      navParent?.appendChild(ul)
    } else {
      let position = document.querySelector(`[data-position="${key}"]`)
      if (position) position.appendChild(ul)
    }

    {/* @ts-ignore */}
    menus.forEach((menu, key) => {
      const li = document.createElement('li')
      const a = document.createElement('a')
      const div = document.createElement('div')

      if (menu.img && !mobile) {
        div.setAttribute('class', 'img-wrapper')
        div.innerHTML = `<a href=${menu.img.url}><img src=${menu.img.src} /></a>`
        ul.appendChild(div)
      }

      let str = ""
      if (menu.title != undefined) {
        str = menu.title.replace(/[^A-Z0-9]+/ig, '') + '_' + key
        li.setAttribute('data-position', str)
        ul.appendChild(li)
      }

      if (menu.url != "#") {
        a.setAttribute('href', menu.url)
      }

      a.setAttribute('data-linkid', str)
      a.textContent = menu.title
      if (menu.secondary) {
        a.classList.add('menu-link', 'secondary-link')
      } else {
        a.classList.add('menu-link')
      }

      li.appendChild(a)

      if (menu.submenu) {
        iterateJsonMenu(menu.submenu, false, str)
      }
    })
  }

  {/* @ts-ignore */}
  function iterateJsonMenuDesktop(menus, initial = true, key = '') {
    const ul = document.createElement('ul')
    {/* @ts-ignore */}
    let newMenus = []

    //check if its initial then append ul or else append inside the li
    if (initial) {
      navParentDesktop?.appendChild(ul)
    }
    else if (!initial) {
      navParentDesktop?.firstElementChild?.remove()
      navParentDesktop?.appendChild(ul)
    }
    else {
      let position = document.querySelector(`[data-position="${key}"]`)
      position?.appendChild(ul)
    }

    {/* @ts-ignore */}
    menus.map(m => { if (m.title === props.selectedMenu) { newMenus = m.submenu } })

    {/* @ts-ignore */}
    newMenus.forEach((menu, key) => {
      const li = document.createElement('li')
      const a = document.createElement('a')

      let str = ""
      if (menu.title != undefined) {
        str = menu.title.replace(/[^A-Z0-9]+/ig, '') + '_' + key
        li.setAttribute('data-position', str)
        ul.appendChild(li)
      }

      if (menu.url != "#") {
        a.setAttribute('href', menu.url)
      }

      a.setAttribute('data-linkid', str)
      a.textContent = menu.title
      if (menu.secondary) {
        a.classList.add('menu-link', 'secondary-link')
      } else {
        a.classList.add('menu-link', 'font-bold')
      }
      li.appendChild(a)

      if (menu.submenu) {
        iterateJsonMenu(menu.submenu, false, str, false)
      }
    })
  }
  // #endregion Menus

  return (
    <>
      {modal === "login" && (
        <Modal contentPosition="center" onClose={closeModal}>
          <LoginForm
            variantLabel="login"
            onClose={closeModal}
            onSwitchModal={(modal: ModalType) => setModal(modal)}
            onAfterLogin={props.onAfterLogin}
          />
        </Modal>
      )}

      {modal === "signup" && (
        <Modal contentPosition="center" onClose={closeModal}>
          <SignUpForm
            variantLabel="signup"
            onClose={closeModal}
            onSwitchModal={(modal: ModalType) => setModal(modal)}
            onAfterLogin={props.onAfterLogin}
          />
        </Modal>
      )}

      {modal === "forgot" && (
        <Modal contentPosition="center" onClose={closeModal}>
          <ForgotPasswordForm
            onClose={closeModal}
            onSwitchModal={(modal: ModalType) => setModal(modal)}
          />
        </Modal>
      )}

      <nav id='slide-menu' className='slide-menu absolute top-0 left-0 w-72 h-full z-1'>
        <div className='controls'>
          {props.isLoggedIn ? (
            <User isLoggedIn={props.isLoggedIn} onLogout={props.onLogout} />
          ) : (
            <LoggedOutUser onLogin={() => setModal("login")} />
          )}
        </div>
      </nav>
    </>
  );
};

export default Menu
